import Dialog from "@material-ui/core/Dialog";
import React from "react";
import { CcIconClose } from "../../icons";
import { CcIconButton } from "../mui";
import { cx } from "../utils";

/**
 * CcModal — Carecentre Zen editorial dialog (replaces glass modals on migrated flows).
 */
const CcModal = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  maxWidth = "sm",
  fullWidth = true,
  className,
  contentClassName,
  disableBackdropClick = false,
  headerActions = null,
  ...props
}) => {
  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === "backdropClick") {
      return;
    }
    onClose?.(event, reason);
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      className={cx("cc-modal-root", className)}
      classes={{ paper: "cc-modal" }}
      {...props}
    >
      <div className="cc-modal__header">
        <div className="cc-modal__header-text">
          {title ? <h2 className="cc-modal__title">{title}</h2> : null}
          {subtitle ? <p className="cc-modal__subtitle">{subtitle}</p> : null}
        </div>
        <div className="cc-modal__header-actions">
          {headerActions}
          {onClose ? (
            <CcIconButton
              label="Close"
              variant="secondary"
              size="sm"
              onClick={(e) => handleClose(e, "escapeKeyDown")}
            >
              <CcIconClose size={18} />
            </CcIconButton>
          ) : null}
        </div>
      </div>

      <div className={cx("cc-modal__body", contentClassName)}>{children}</div>

      {footer ? <div className="cc-modal__footer">{footer}</div> : null}
    </Dialog>
  );
};

export default CcModal;
